export function objectKeys<TObj extends object>(obj: TObj): [keyof typeof obj] {
  return Object.keys(obj) as [keyof typeof obj]
}
